import { styled, Typography } from '@material-ui/core'

export const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  fontSize: '0.6875rem',
}))
